import { Injectable } from "@angular/core";
import { NavigationService } from "./navigation.service";
import { NotificationsService } from "./notification.service";
import { ApiHttpClient } from "./api-http-client";
import { BroadcastService } from "./broadcast.service";

@Injectable()
export class BaseComponentContext{
        constructor(public http: ApiHttpClient, 
                public navService: NavigationService, 
                public notificationService: NotificationsService,
                public broadcastService: BroadcastService) {
        }
}